<template>
  <div class="container pt-2 pt-md-4 page-content">
    <div class="row">
      <div class="col-12">
        <h1>FAQ
          <br>(Perguntas Frequentes)
        </h1>
        <div class="row">
          <div class="col-lg-6" v-for="faqs in columnFaqs" :key="faqs">
            <faq-collapse v-for="faq in faqs" :faq="faq" :key="faq.id"></faq-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FaqCollapse from "./FaqCollapse";

export default {
  name: "faq",
  components: { FaqCollapse },
  computed: {
    columnFaqs: function() {
      return [
        this.faqs.slice(0, Math.ceil(this.faqs.length / 2)),
        this.faqs.slice(Math.ceil(this.faqs.length / 2))
      ];
    }
  },
  data: () => {
    return {
      faqs: [
        {
          question: "Atendimento a Deficientes Auditivos",
          answer: `<p>Para utilizar a CIC (Central de Intermediação e Comunicação) – Central de Libras você pode fazer o download do app disponível na Apple Store e na Google Play, e também através do site <a href="https://v3.icom-libras.com.br/w/tim/webview" target=" _blank">https://v3.icom-libras.com.br/w/tim/webview</a></p>`
        },
        {
          question: "O que é o Serviço TIM finanças?",
          answer: `<p>
									O TIM finanças oferece conteúdos sobre o mundo das Finanças, por meio do celular, computador e tablet. Você pode acessá-lo a qualquer hora e em qualquer lugar. O Serviço disponibiliza na categoria Meu Negócio conteúdos relacionados a empreendedorismo, estratégias de negociação, marketing, vendas, análise de mercado, planejamento financeiro, plano de negócios, registro de empregados, salário e jornada de trabalho, entre outros temas. Já na categoria Minhas Finanças o usuário terá acesso a conteúdos relacionados ao gerenciamento das finanças pessoais, planejamento do orçamento pessoal e doméstico, como investir melhor o seu dinheiro, dicas de economia, entre outros temas.
								</p>`
        },
        {
          question: "Como faço para assinar o serviço o TIM finanças?",
          answer: `	<p>
									Você pode ter o serviço TIM finanças incluso no seu plano. Caso o seu plano não possua este benefício, você pode contratar de forma avulsa. Para assinar o Serviço via SMS (mensagem de texto), você deverá enviar o comando OK para o número 6634 ou qualquer outro divulgado para assinatura do Serviço por R$ 5,19 por semana. Você também pode fazer a contratação via aplicativo: basta fazer o download do Aplicativo através da lojas Apple ou Android. Após instalá-lo, dentro do Aplicativo, clique em “Inscrever-se”. Na sequência, insira o seu número TIM para assinar o serviço e receber o código de confirmação no seu celular que será utilizado como senha.
								</p>`
        },
        {
          question:
            "Quais planos/ofertas possuem o serviço incluído, sem custo adicional?",
          answer: `	<p>
									Os clientes de alguns planos corporativos possuem o beneficio TIM finanças com direito a utilização do aplicativo por estar incluído na sua franquia do plano sem custo adicional.
								</p>`
        },
        {
          question: " O Serviço TIM finanças só pode ser acessado no celular?",
          answer: `	<p>
									Você pode acessar o TIM finanças pelo smartphone, tablet ou computador.
								</p>`
        },
        {
          question:
            " Qual o valor da assinatura do serviço e quais são as formas de pagamento?",
          answer: `	<p>
									Você tem acesso ilimitado ao conteúdo do TIM finanças por <strong>R$ 5,19</strong> por semana. Clientes pré-pagos são tarifados através do saldo de seus créditos Pré. Clientes pós-pagos são debitados na fatura (conta).
								</p>`
        },
        {
          question:
            " Recebi o link por SMS, como faço para acessar minhas aulas?",
          answer: `	<p>
									Basta clicar no <em>link</em> e o site será carregado em seguida. Certifique-se de que seu aparelho seja capaz de navegar na internet com o formato HTML5.
								</p>`
        },
        {
          question:
            "Meu celular não possui este tipo de navegação, mesmo assim poderei acessar minhas aulas?",
          answer: `<p>
									Sim. Você poderá acessar suas aulas através do webapp do serviço disponível no link: <a href="http://app.timfinancas.com.br" target ="_blank"><i>http://app.timfinancas.com.br.</i></a> Acesse com o seu número TIM e pronto, todas as aulas estarão disponíveis para você acessar a hora que quiser.
								</p>`
        },
        {
          question: "Com que frequência receberei o SMS com o conteúdo?",
          answer: `	<p>
									Em dias alternados você receberá dicas via SMS com o <i>link</i> para acessar a aula no site móvel.
                </p>

                <p>
								Por exemplo, se você assinou o serviço na segunda-feira, você recebera a 1ª aula na segunda-feira e a 2ª aula na quarta-feira.</p>`
        },
        {
          question: "Como são distribuídos os conteúdos do Serviço?",
          answer: `	<p>
								No TIM finanças você receberá dicas via SMS com o <i>link</i> para acessar a aula no site móvel; ao acessar o site móvel você poderá ler o conteúdo completo da aula, assistir a videoaula, ouvir o podcast e responder as perguntas referentes a aula do dia.
								</p>
								<p>
									Todos esses conteúdos também estão disponíveis no Aplicativo.
								</p>
								<p>
									Atenção! Ao assistir as videoaulas você poderá ser tarifado pelo tráfego de dados ou ter parte do seu pacote consumido.
								</p>`
        },
        {
          question: "Toda aula possui vídeo?",
          answer: `	<p>
                  Nem sempre! Apenas os módulos que exigem um maior aprofundamento no tema possuem vídeo.
                </p>
								<p>
									Atenção! Ao assistir as videoaulas você poderá ser tarifado pelo tráfego de dados ou ter parte do seu pacote consumido.
								</p>`
        },
        {
          question: " É possível acessar o TIM finanças em modo offline?",
          answer: `	<p>
                    Sim! Você pode acessar o Aplicativo TIM finanças mesmo sem internet. Dentro das lições,
										você pode fazer <i>download</i> dos diferentes conteúdos da respectiva lição.
                </p>`
        },
        {
          question: "Qual a escolaridade ou a idade mínima necessária?",
          answer: `		<p>
                		Não há exigência de escolaridade ou idade mínima. O serviço TIM finanças é didático e com uma linguagem simples, por isso pode ser feito por pessoas de qualquer idade e escolaridade, sem dificuldades.
								</p>`
        },
        {
          question:
            "Existe um prazo para concluir um dos temas do TIM finanças?",
          answer: `		<p>
									Não existe um prazo para conclusão do TIM finanças. Você pode fazê-lo no seu ritmo e de acordo com a sua disponibilidade.
								</p>`
        },
        {
          question: "Como faço para cancelar o TIM finanças?",
          answer: `		<p>
									Via SMS: Envie SAIR para o número 6634.
								</p>
								<p>
									Caso queira assinar o serviço novamente após o cancelamento, seu desempenho será mantido e você poderá voltar na aula que parou.
								</p>`
        },
        {
          question: "Como solicitar exclusão dos meus dados no TIM finanças?",
          answer: `		<p>
                  Para excluir seus dados do nosso sistema, você precisa entrar em contato conosco clicando <a href="https://forms.gle/2XeYcZQPLE5muko87" target ="_blank">aqui</a>.
                  Após a sua solicitação, nossa equipe removerá todos os seus dados do aplicativo TIM finanças.
								</p>`
        },
        {
          question: "Não obteve a resposta que procurava?",
          answer: `	<p>
            Não se preocupe, estamos aqui para ajudá-lo. Preencha nosso formulário de suporte clicando <a href="https://forms.gle/2XeYcZQPLE5muko87" target ="_blank">aqui</a>.
								</p>`
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/globals.scss";
h1 {
  font-size: 2.5rem;
  font-weight: bold;
  color: #003c63;
  margin-bottom: 27px;
  margin-top: 52px;
}
.faq-collapse {
  font-weight: 500;
}

@media (max-width: 360px) {
  .page-content {
    padding-bottom: 400px;
  }
}

@media (max-width: 576px) {
  .page-content {
    padding-bottom: 373px;
  }
}

@media (min-width: 750px) {
  .page-content {
    padding-bottom: 156px;
  }
}
</style>



// WEBPACK FOOTER //
// Faq.vue?3963bdac